import React from "react";

import type { JSX } from "react";

interface Props {
  label: string | JSX.Element;
  onAddFile: (file: File) => void;
  id: string;
  accept: string;
}

export default function FileUpload({
  label,
  onAddFile,
  id,
  accept,
}: Props): JSX.Element {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target?.files?.[0]) {
      onAddFile(e.target.files[0]);
    }
  };

  return (
    <React.Fragment>
      <label
        className="m-0 flex cursor-pointer align-middle font-normal"
        htmlFor={id}
      >
        {typeof label === "string" ? (
          <span className="whitespace-nowrap">{label}</span>
        ) : (
          label
        )}
      </label>
      <input
        accept={accept}
        className="hidden"
        id={id}
        onChange={handleInputChange}
        type="file"
      />
    </React.Fragment>
  );
}
